import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { ElementType } from "../dom-tools/ElementType";
import { OnClick } from "../dom-tools/EventListeners";


export class ScrollTo
{
  static readonly attribute = new ElementAttribute( "scroll--to" );
  static readonly blockMode = new ElementAttribute( "block--mode" );

  static applyOnDocument()
  {
    ScrollTo.attribute.forEachInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  { 
    OnClick.add( e as HTMLElement, 
      ev =>
      {
        let element = document.querySelector( ScrollTo.attribute.from( e ) );
        let blockMode = ScrollTo.blockMode.from( e, "start" ) as ScrollLogicalPosition;
        element.scrollIntoView( { behavior:"smooth", block: blockMode } );
      }
    );
  } 
}